import { Form, Input, DatePicker, InputNumber, Col, Row, Select, Button, message, Space } from "antd";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { dictsGetUsers } from "../../extensions/dicts";
import { serverFetch } from "../../server";
import { strDate2Server } from "../../extensions/utils";
import { paymentsVids } from "../../extensions/helper";
import { LogMonitor } from "@/controls";
import { isMobile } from "@/extensions/design";
import "./payments.css"

const PaymentEditModal = ({ onClose, record }) => {
  const [form] = Form.useForm();
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [item, setItem] = useState({});

  useEffect(() => {
    dictsGetUsers(setUsers, { activeOnly: true });
  }, []);

  useEffect(() => {
    if (record) {
      const initial = {
        ...record,
        docDate: record.docDate ? dayjs(record.docDate) : null,
      };
      form.setFieldsValue(initial);
      setItem(initial);
    } else {
      form.resetFields();
      setItem({});
    }
  }, [record, form]);

  const onValuesChange = (_, allValues) => {
    const normalized = { ...allValues };
    if (normalized.docDate) normalized.docDate = strDate2Server(normalized.docDate);
    setItem(prev => ({ ...record, ...prev, ...normalized }));
  };

  const onSave = async () => {
    setLoading(true);
    try {
      const values = await form.validateFields();
      const payload = {
        ...record,
        ...values,
        docDate: values.docDate ? strDate2Server(values.docDate) : null,
      };
      await serverFetch("payment", {
        method: "PUT",
        bodyData: payload,
      });
      onClose(true);
    } catch (e) {
      message.error(e?.userMessage || e?.message || "Ошибка при сохранении");
    } finally {
      setLoading(false);
    }
  };

  return !isMobile ? (
    <Form form={form} layout="horizontal" colon={false} onValuesChange={onValuesChange} labelCol={{ span: 6 }} wrapperCol={{ span: 18 }} style={{ marginTop: "60px" }}>
      <Row style={{ marginLeft: "6px" }}>
        <Col span={14}>
          <Form.Item label="Дата" name="docDate" labelCol={{ span: 10 }} wrapperCol={{ span: 14 }}><DatePicker disabled format="DD.MM.YYYY" style={{ width: "75%" }} /></Form.Item>
        </Col>
        <Col span={10}>
          <Form.Item label="Визит" name="visitId" labelCol={{ span: 10 }} wrapperCol={{ span: 14 }}><Input disabled style={{ width: "100%" }} /></Form.Item>
        </Col>
      </Row>
      <Form.Item label="Основание" name="productName" getValueProps={(value) => ({ value: value || item.paymentVid2Name })}><Input disabled /></Form.Item>
      {/* <Row style={{ marginLeft: "6px" }}> */}
        {/* <Col span={14}> */}
          <Form.Item label="Менеджер" name="managerName" /* labelCol={{ span: 10 }} wrapperCol={{ span: 14 }} */><Select disabled style={{ width: "70%" }} options={users} /></Form.Item>
        {/* </Col> */}
        {/* <Col span={10}>
          <Form.Item label="Исполнитель" name="executorName" labelCol={{ span: 10 }} wrapperCol={{ span: 14 }}><Select disabled style={{ width: "100%" }} options={users} /></Form.Item>
        </Col> */}
      {/* </Row> */}
      <Row style={{ marginLeft: "6px" }}>
        <Col span={14}>
          <Form.Item label="Вид" name="vid" labelCol={{ span: 10 }} wrapperCol={{ span: 14 }}><Select disabled style={{ width: "70%" }} options={paymentsVids} /></Form.Item>
        </Col>
        <Col span={10}>
          <Form.Item label="Вид оплаты" name="paymentVidName" labelCol={{ span: 10 }} wrapperCol={{ span: 14 }}><Select disabled style={{ width: "100%" }} /></Form.Item>
        </Col>
      </Row>
      <Form.Item label="Счет" name="paymentVid2Name"><Select disabled style={{ width: "100%" }}/></Form.Item>
      <Form.Item label="Клиент" name="clientName"><Input disabled /></Form.Item>
      <Row style={{ marginLeft: "6px" }}>
        <Col span={14}>
          <Form.Item label="Сумма" name="syma" labelCol={{ span: 10 }} wrapperCol={{ span: 14 }}><InputNumber disabled style={{ width: "70%" }} /></Form.Item>
        </Col>
        <Col span={10}>
          <Form.Item label="Пользователь" name="userName" labelCol={{ span: 10 }} wrapperCol={{ span: 14 }}><Select disabled options={users} /></Form.Item>
        </Col>
      </Row>
      <Form.Item label=" ">
        <Space>
          <LogMonitor vid={6} id={record?.id}/>
          <Button className="sport-btn-wide" onClick={() => onClose(false)}>Закрыть</Button>
        </Space>
      </Form.Item>
    </Form>
  ) : (
    <Form form={form} loading={loading} layout="inline" colon={false} labelCol={{ xs: 4 }} onValuesChange={onValuesChange}>
      <Row align="middle" className="records-row-mobile">
        <Col>
          <Form.Item label="Дата" name="docDate" labelCol={{ span: 4 }} wrapperCol={{ span: 7}} className="record-form-item-with-margin-top-mobile">
            <DatePicker disabled format="DD.MM.YYYY" className="sales-small-input-mobile"/>
          </Form.Item>
        </Col>
        <Col>
          <Form.Item label="Визит" name="visitId" labelCol={{ span: 2 }} wrapperCol={{ span: 7}} className="record-form-item-with-margin-top-mobile">
            <Input disabled className="sales-small-input-mobile"/>
          </Form.Item>
        </Col>
      </Row>
      <Form.Item label="Основание" name="productName" getValueProps={(value) => ({ value: value || item.paymentVid2Name })} className="record-form-item-with-margin-top-mobile">
        <Input disabled className="records-form-item-mobile"/>
      </Form.Item>
      <Form.Item label="Менеджер" name="managerName" className="record-form-item-with-margin-top-mobile">
        <Select disabled className="records-form-item-mobile" options={users} />
      </Form.Item>
      <Row align="middle" className="records-row-mobile">
        <Col>
          <Form.Item label="Вид" name="vid" className="record-form-item-with-margin-top-mobile">
            <Select disabled options={paymentsVids} className="payments-form-item-mobile"/>
          </Form.Item>
        </Col>
        <Col>
          <Form.Item label="Опл." labelCol={{ span: 1 }} name="paymentVidName" className="record-form-item-with-margin-top-mobile">
            <Select disabled className="payments-form-item-mobile"/>
          </Form.Item>
        </Col>
      </Row>
      <Form.Item label="Клиент" name="clientName" className="record-form-item-with-margin-top-mobile">
        <Input disabled className="records-form-item-mobile"/>
      </Form.Item>
      <Form.Item label="Cчет" name="paymentVid2Name" className="record-form-item-with-margin-top-mobile">
        <Select disabled className="records-form-item-mobile"/>
      </Form.Item>
      <Form.Item label="Сумма" name="syma" className="record-form-item-with-margin-top-mobile">
        <InputNumber disabled className="records-form-item-mobile" />
      </Form.Item>

      <Form.Item label="Польз." name="userName" className="record-form-item-with-margin-top-mobile">
        <Select disabled options={users} className="records-form-item-mobile"/>
      </Form.Item>
      <div className="record-form-item-with-margin-top-mobile" style={{display: "flex", justifyContent:"space-around"}}>
        <LogMonitor vid={6} id={record?.id}/>
      </div>
    </Form>
  );
};

export default PaymentEditModal;
